import type { ReactNode } from 'react'
import { Text } from '@/ui/layout/Text'
import styles from './Facts.module.css'

/**
 * A label/value list (`dl`): caption labels in `text-mute` beside values in
 * `text-sub`. The resource detail bodies and the connection sections share it.
 */
export function Facts({ children }: { children: ReactNode }) {
  return <dl className={styles.facts}>{children}</dl>
}

export function Fact({
  label,
  children,
}: {
  label: string
  children: ReactNode
}) {
  return (
    <>
      <Text as="dt" variant="caption" tone="text-mute">
        {label}
      </Text>
      <Text as="dd" tone="text-sub" className={styles.value}>
        {children}
      </Text>
    </>
  )
}
